module.exports = __webpack_public_path__ + "50a7019a0d27755700c422b7846193ff.pdf";